import "./paypalButton.css";
import React, { useEffect, useState, useContext, useCallback } from "react";
import { loadPayPalCheckout } from "./payPalCheckout";
import BraintreeStateContext from "./BraintreeStateContext";
import MainStateContext from "../state/mainStateContext";
import { triggerEvent, triggerEventOnce, wvusLogger } from "../helpers";
import Shimmer from "../components/Shared/Shimmer";
import { getPhrase } from "../languages";

export function PayPalButton(props) {
  const { heightSize = 50 } = props;
  const { state, setPayButtonStatus } = useContext(BraintreeStateContext);
  const {
    state: mainState,
    setSubmitMessagePhraseKey,
    toggleOverlay
  } = useContext(MainStateContext);
  const { clientToken, status: payButtonStatus } = state;
  const { products } = mainState;
  const [isPaymentClick, setIsPaymentClick] = useState(false);
  const {
    buttonId = "paypal-button",
    onPaymentComplete,
    onPaymentError = () => {},
    onPaymentCancel = () => {},
    disabled = false
  } = props;
  const disabledClass = disabled === true ? "disabled" : "";
  const buttonStyles = {
    "--paypal-button-height-size": `${heightSize}px`
  };

  useEffect(() => {
    if (products?.length && isPaymentClick) {
      fireCheckoutBegin();
    }
  }, [products, isPaymentClick]);

  const fireCheckoutBegin = useCallback(() => {
    triggerEventOnce("add_to_cart", { products });
    triggerEvent("begin_checkout_alt_pay", { products, eventLabel: "paypal" });
    triggerEventOnce("begin_checkout", { products });

    const timeoutId = setTimeout(() => {
      setIsPaymentClick(false);
      clearTimeout(timeoutId);
    }, 1000);
  }, [products]);

  const onComplete = (...args) => {
    toggleOverlay(true);
    onPaymentComplete(...args);
  };

  const onLoadError = ({ error }) => {
    setPayButtonStatus("error");
    wvusLogger.log(error, wvusLogger.getLogLevelNames().ERROR);
  };

  const onError = (result) => {
    onPaymentError(result);
    toggleOverlay(false);

    const { error } = result;
    const errorDetail = error.message || error;

    setSubmitMessagePhraseKey("errors.general_error_volunteer");

    wvusLogger.log(error, wvusLogger.getLogLevelNames().ERROR);

    triggerEvent("error_view", {
      error_message: getPhrase("errors.general_error_volunteer"),
      error_type: "paypal_error",
      event_label: errorDetail,
      checkout_type: products?.length ? `flex_checkout:${products[0].sku}` : "flex_checkout"
    });
  };

  const onCancel = (...args) => {
    onPaymentCancel(...args);
    toggleOverlay(false);
  };

  const onPaymentClick = () => {
    setSubmitMessagePhraseKey("");
    setIsPaymentClick(true);
  };

  const onInit = () => {
    setPayButtonStatus("ready");
  };

  useEffect(() => {
    if (clientToken) {
      loadPayPalCheckout({
        clientToken,
        heightSize,
        buttonId: `#${buttonId}`,
        onComplete,
        onError,
        onLoadError,
        onCancel,
        onPaymentClick,
        onInit
      });
    }
  }, [clientToken]);

  useEffect(() => {
    if (clientToken && products?.length) {
      triggerEventOnce("alt_pay_view_paypal", { products });
    }
  }, [clientToken, products]);

  return (
    <Shimmer
      className="paypal-wrapper"
      width="100%"
      height="50px"
      isLoading={payButtonStatus === "pending"}>
      {payButtonStatus === "error" || payButtonStatus === "disabled" ? null : (
        <div
          id={buttonId}
          className={`paypal-button-label-container ${disabledClass}`}
          style={buttonStyles as React.CSSProperties}></div>
      )}
    </Shimmer>
  );
}

export default PayPalButton;
